import { IGame } from "../Interfaces";

const starryNight: IGame = {
  "name": "Starry Night",
  "author": "Yihao",
  "time": new Date("2020-08-31T12:00:00.000Z"),
  "description": "This game mimics the blinking stars in a clear night.",
  "refreshFrequency": 2,
  "width": 20,
  "height": 20,
  "seeds": [
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ]
  ],
  "surviveRangeLower": 2,
  "surviveRangeUpper": 3,
  "reproductionRangeLower": 3,
  "reproductionRangeUpper": 3,
  "borderPolicy": "dead",
  "styles": [
    [
      {
        "size": 100,
        "color": "#1f4758",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#1e4f60",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#549d99",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#f8e6a5",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#1f4758",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#1f4758",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#1f4758",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#1f4758",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 100,
        "color": "#1f4758",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      }
    ],
    [
      {
        "size": 80,
        "color": "green",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 100,
        "color": "#f5f0e0",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 70,
        "color": "#ffc616",
        "backgroundColor": "#fedd66",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 80,
        "color": "green",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 80,
        "color": "green",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 80,
        "color": "green",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 80,
        "color": "green",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 80,
        "color": "green",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      },
      {
        "size": 80,
        "color": "green",
        "backgroundColor": "white",
        "borderColor": "gray",
        "borderRadius": 50,
        "borderWidth": 0,
        "elevation": 5
      }
    ]
  ]
};

export default starryNight;